import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
	onCreateAdminLiveFaceSession,
	onCreateVerificationLivenessSession,
	onGetDetailPlaces,
	onGetPlaces,
	onGetVerificationCode,
	onSaveAdminLiveFaceResult,
	onSaveVerificationLivenessResult,
	onSendVerificationPhoto,
} from "./SettingsThunk";
import Search from "../../domain/entities/Search";
import LocationDetails from "../../domain/entities/LocationDetails";
import { Partner } from "../../domain/entities/Partner";
import {
	VerificationLivenessSession,
	VerificationUploadResult,
} from "../../domain/entities/VerificationUploadResult";


interface SettingsState {
	isLoading: boolean;
	settingsLoading: boolean;
	error?: string;
	verificationCode?: string;
	search: Search[];
	partner: Partner[];
	locationDetails?: LocationDetails;
}

const initialState: SettingsState = {
	isLoading: false,
	settingsLoading: false,
	error: undefined,
	verificationCode: undefined,
	search: [],
	partner: [],
	locationDetails: undefined,
};

const settingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(onGetVerificationCode.pending, (state) => {
				state.settingsLoading = true;
			})
			.addCase(
				onGetVerificationCode.fulfilled,
				(state, action: PayloadAction<string>) => {
					state.settingsLoading = false;
					state.verificationCode = action.payload;
				}
			)

			.addCase(onGetVerificationCode.rejected, (state, action) => {
				state.error = action.error.message;
				state.settingsLoading = false;
			})
			.addCase(onSendVerificationPhoto.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onSendVerificationPhoto.fulfilled,
				(state, action: PayloadAction<VerificationUploadResult>) => {
					state.isLoading = false;
				}
			)
			.addCase(onSendVerificationPhoto.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			})
			.addCase(onSaveVerificationLivenessResult.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onSaveVerificationLivenessResult.fulfilled,
				(state, action: PayloadAction<string>) => {
					state.isLoading = false;
				}
			)
			.addCase(onSaveVerificationLivenessResult.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			})
			.addCase(onCreateVerificationLivenessSession.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onCreateVerificationLivenessSession.fulfilled,
				(state, action: PayloadAction<VerificationLivenessSession>) => {
					state.isLoading = false;
				}
			)
			.addCase(onCreateVerificationLivenessSession.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			})
			.addCase(onCreateAdminLiveFaceSession.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onCreateAdminLiveFaceSession.fulfilled,
				(state, action: PayloadAction<VerificationLivenessSession>) => {
					state.isLoading = false;
				}
			)
			.addCase(onCreateAdminLiveFaceSession.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			})
			.addCase(onSaveAdminLiveFaceResult.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onSaveAdminLiveFaceResult.fulfilled,
				(state, action: PayloadAction<string>) => {
					state.isLoading = false;
				}
			)
			.addCase(onSaveAdminLiveFaceResult.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			})
			.addCase(onGetPlaces.pending, (state) =>{
				state.settingsLoading = true;
			})
			.addCase(onGetPlaces.fulfilled, 
				(state, action: PayloadAction<Search[]>) =>{
				state.settingsLoading = false;
				state.search = action.payload;
			})
			.addCase(onGetPlaces.rejected, (state, action) => {
				state.error = action.error.message;
				state.settingsLoading = false;
			})

			
			.addCase(onGetDetailPlaces.pending, (state) =>{
				state.isLoading = true;
			})
			.addCase(onGetDetailPlaces.fulfilled, 
				(state, action: PayloadAction<LocationDetails>) =>{
					state.isLoading = false;
					state.locationDetails = action.payload;
			})
			.addCase(onGetDetailPlaces.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
			});
	},
});
export default settingsSlice.reducer;
